// SplashSlide — first slide. Logo scale-in + title fade. Auto-advances after
// ~1.6s. No chrome (no progress bar, no skip), this is a moment.
//
// Lifted in spirit from /opt/4bix-source/SplashScreen.tsx but uses framer-
// motion (already in deps) instead of GSAP.

import { useEffect } from 'react'
import { motion } from 'framer-motion'
import { useOnboarding } from '../useOnboarding'

export default function SplashSlide() {
  const { next } = useOnboarding()

  useEffect(() => {
    const t = window.setTimeout(next, 1600)
    return () => window.clearTimeout(t)
  }, [next])

  return (
    <div className="fixed inset-0 z-[80] bg-white dark:bg-gray-950 flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <motion.img
          src="/logo.png"
          alt="Go2Fix"
          className="w-24 h-24 rounded-3xl"
          initial={{ scale: 0.6, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.5, ease: 'easeOut' }}
        />
        <motion.div
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.3 }}
          className="text-center"
        >
          <p className="text-2xl font-bold text-gray-900 dark:text-white tracking-tight">Go2Fix</p>
          <p className="text-sm text-gray-500 mt-0.5">Servicii la domiciliu</p>
        </motion.div>
      </div>
    </div>
  )
}
